import repository from '../../repositories/crm/crm.opportunity.activity.repository';

const edit = (id, changes) =>
    repository.edit(id, changes);

const editConclusion = (id, isConcluding, options = {}) =>
    repository
        .editConclusion(id, isConcluding, options)
        .then(res => res.data || {});

const getRelativeDayLabel = (activitiesDeadline) => {

    if (!activitiesDeadline || !isDateValid(activitiesDeadline))
        return 'Sem data definida';

    const deadlineDate = new Date(activitiesDeadline + 'T10:00:00');
    const currentDate = new Date();
    const tomorrowDate = new Date(new Date().setDate(currentDate.getDate() + 1));

    if (deadlineDate.toDateString() === currentDate.toDateString())
        return 'Hoje';

    if (deadlineDate.toDateString() === tomorrowDate.toDateString())
        return 'Amanhã';

    return null;
}

const capitalize = (value = '') => value.charAt(0).toUpperCase() + value.slice(1);

const withoutAbbreviationDot = (value = '') => value.replace(/\./g, '');

const getDeadlineShortLabel = (activitiesDeadline) => {

    const relativeLabel = getRelativeDayLabel(activitiesDeadline);
    if (relativeLabel)
        return relativeLabel;

    const deadlineDate = new Date(activitiesDeadline + 'T10:00:00');

    const weekday = withoutAbbreviationDot(deadlineDate.toLocaleDateString('pt-BR', { weekday: 'short' }));
    const month = withoutAbbreviationDot(deadlineDate.toLocaleDateString('pt-BR', { month: 'short' }));

    return `${capitalize(weekday)}, ${deadlineDate.getDate()} ${month}`;
}

const getWeekdayName = (date) =>
    new Date(date + 'T10:00:00').toLocaleDateString('pt-BR', { weekday: 'long' }).replace('-feira', '');

const getDayLabel = (date) =>
    `${getWeekdayName(date)}, ${new Date(date + 'T10:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}`;

const isDateValid = (dateStr) => !isNaN(new Date(dateStr));

export default {
    edit,
    editConclusion,
    getDeadlineShortLabel,
    getWeekdayName,
    getDayLabel,
}
